import { Observable } from "rxjs";

export abstract class ResetPasswordService {
  /**
   * This method is used to reset the user's password.
   * @param email
   */
  abstract execute(email: string): Observable<void>;
}
